import { render, staticRenderFns } from "./institutionsindex.vue?vue&type=template&id=65a6ac10&scoped=true&"
import script from "./institutionsindex.vue?vue&type=script&lang=js&"
export * from "./institutionsindex.vue?vue&type=script&lang=js&"
import style0 from "./institutionsindex.vue?vue&type=style&index=0&id=65a6ac10&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a6ac10",
  null
  
)

export default component.exports